import SelectTripType from "./SelectTripType";

export default SelectTripType;
